// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__1e_Lt","button":"NotFound_button__31YMD"};